"use client";

import { getBrandClient } from "@/utils/get-brand-client";
import { Divider } from "@stone-payments/jade";
import { Feedback } from "@/components/feedback";
import { FooterLegal } from "@/components/footer";

type GlobalFeedbackProps = {
  data: Parameters<typeof Feedback>[number];
};

const GlobalFeedback = ({ data }: GlobalFeedbackProps) => {
  const brand = getBrandClient();

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <div className="w-full flex-1 px-4">
        <Feedback {...data} />
      </div>

      <div className="w-full">
        <Divider />
      </div>

      <div className="py-8">
        <FooterLegal brand={brand} />
      </div>
    </div>
  );
};

export { GlobalFeedback };
